import React, { useRef } from 'react';
import { Box, Typography, IconButton, Avatar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import useDeviceInfo from '../../utils/useDeviceInfo';
import AIChat from '../../components/ai/AIChat';
import MessageCreditGauge from '../../components/ai/MessageCreditGauge';

const AIChatPage = () => {
  const navigate = useNavigate();
  const { paddingTop } = useDeviceInfo();
  const gaugeRef = useRef();

  const handleBackClick = () => {
    navigate('/');
  };

  const handleMessageSent = () => {
    if (gaugeRef.current?.refreshCredits) {
      gaugeRef.current.refreshCredits();
    }
  };

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto' }}>
      {/* En-tête */}
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderBottom: '1px solid #DDD',
          display: 'flex',
          width: '100%',
          zIndex: 100,
          position: 'fixed',
          top: 0,
          alignItems: 'center',
          px: 2,
          pt: paddingTop + 2,
          pb: 2,
        }}
      >
        <IconButton sx={{ p: 0 }} aria-label="retour" onClick={handleBackClick}>
          <ArrowBackIcon />
        </IconButton>

        <Avatar
          src="https://data.heyraoul.fr/img/avatars/user/004.jpg"
          sx={{ width: 36, height: 36, ml: 2, border: '1px solid #DDD' }}
        />
        <Typography variant="body" fontWeight="bold" sx={{ flexGrow: 1, ml: 1 }}>
          Raoul
        </Typography>


        <Box sx={{ ml: 2 }}>
          <MessageCreditGauge ref={gaugeRef} />
        </Box>

      </Box>

      {/* Chat IA */}
      <Box sx={{ pt: paddingTop + 8 }}>
        <AIChat onMessageSent={handleMessageSent} />
      </Box>
    </Box>
  );
};

export default AIChatPage;
